import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Image from '@tcp/core/src/components/common/atoms/Image';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import style from './AnimatedSearchIcon.style';

const AnimatedSearchIcon = ({ className, iconLabel, iconPath, disableAnimation }) => {
  const [animate, setAnimation] = useState(false);
  useEffect(() => {
    setAnimation(true);
  }, []);
  return (
    <BodyCopy
      component="div"
      className={`${className} ${animate && 'slider-icon-wrapper'}  ${
        disableAnimation && 'disable-animation'
      }`}
    >
      <BodyCopy
        className="icon-text"
        fontSize="fs14"
        component="p"
        fontFamily="secondary"
        fontWeight="bold"
      >
        {iconLabel}
      </BodyCopy>
      <Image src={iconPath} className="discovery-icon" id="discoveryIcon" />
    </BodyCopy>
  );
};

AnimatedSearchIcon.defaultProps = {
  className: '',
  iconLabel: '',
  iconPath: '',
  reverseOrder: false,
  disableAnimation: false,
};

AnimatedSearchIcon.propTypes = {
  className: PropTypes.string,
  iconLabel: PropTypes.string,
  iconPath: PropTypes.string,
  reverseOrder: PropTypes.bool,
  disableAnimation: PropTypes.bool,
};

export default withStyles(AnimatedSearchIcon, style);
export { AnimatedSearchIcon as AnimatedSearchIconVanilla };
